/**
 * Navigation state attached to the redirect of a rejected AuthGuard, so the
 * side effects of the rejection can be handled outside the guard.
 */
export const AUTH_GUARD_REJECTED_STATE = 'authGuardRejected';
